// Components==============
import React, { createContext, useMemo, useState } from 'react';
import { usePermission } from 'hooks/usePermission';
// =========================

export const initialOpenNavItems = {
  bibliotheek: false,
  werkplaats: false,
  show: false,
  scan: false,
  groei: false,
};
export const initialOpenNavItemsForExtern = {
  bibliotheek: false,
  werkplaats: true,
  show: false,
  scan: false,
  groei: false,
};

type OpenNavItems = typeof initialOpenNavItems;

type GlobalOpenNavItemsContextType = {
  openNavItems: OpenNavItems;
  setOpenNavItems: React.Dispatch<React.SetStateAction<OpenNavItems>>;
};

export const GlobalOpenNavItemsContext = createContext(
  {} as GlobalOpenNavItemsContextType
);

export default function GlobalOpenNavItems({
  children,
}: {
  children: React.ReactNode;
}) {
  const isExtern = usePermission(['Extern']);
  const [openNavItems, setOpenNavItems] = useState(
    isExtern ? initialOpenNavItemsForExtern : initialOpenNavItems
  );

  const value = useMemo(
    () => ({
      openNavItems,
      setOpenNavItems,
    }),
    [openNavItems]
  );

  return (
    <GlobalOpenNavItemsContext.Provider value={value}>
      {children}
    </GlobalOpenNavItemsContext.Provider>
  );
}
